<div [class]="!isMobile ? 'container mt-5 ps-5 min-vh-79 mb-5 profile-settings-pc' : 'profile-settings-mb'">
 <ng-container *ngIf="isMobile; else pcHeaderPartTemplate">
    <div class="tab-scroll-wrapper bg-white">
      <nav mat-tab-nav-bar class="tab-scroll-bar" [disablePagination]="true" [tabPanel]="tabPanel">
        <a mat-tab-link *ngFor="let item of getMenuItems"
           (click)="navigateToPage(item)"
           [active]="isRouteActive(item)">{{ item }}</a>
      </nav>
      <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
    </div>
  </ng-container>
  <ng-template #pcHeaderPartTemplate>
    <div class="row">

      <div class="card-header py-3">
        <div class="d-flex align-items-start flex-row gap-3">
          <mat-icon [routerLink]="['/dashboard']" class="d-flex text-gray align-items-center justify-content-center cursor-pointer">chevron_left</mat-icon>
          <div class="d-flex align-items-start flex-column gap-1">
            <span class="fs-3 fw-bold">Test Configuration</span>
            <span class="fs-4 fw-light text-gray">{{ getQuizName() }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <div [class]="!isMobile ? 'row' : 'col-md-9 h-100 w-100'">
    <ng-container *ngIf="!isMobile">
      <div class="card col-md-3 min-vh-79 mt-5">
        <nav id="sidebar" class="ml-3 mt-5">
          <ul class="list-unstyled components">
            <li>
              <a (click)="toggleTestConfigurationDropdown()" data-toggle="collapse"
                 class="dropdown-toggle cursor-pointer">Test
                Configuration</a>
              <ul *ngIf="isTestConfigurationDropdownOpen" class=" list-unstyled">
                <li>
                  <div class="step">
                    <a routerLinkActive="active" [routerLink]="['/quiz/add']" [queryParams]="{ id: quizId }"
                       type="button" class="step-trigger"
                       role="tab" id="basicSettings">
                      <span class="bs-stepper-label">Basic settings</span>
                    </a>
                  </div>
                </li>
                <li>
                  <div class="step">
                    <a routerLinkActive="active" [routerLink]="['/quiz/question/manager']" [queryParams]="{ id: quizId }"
                       type="button" class="step-trigger"
                       role="tab" id="questionManager"
                       >
                      <span class="bs-stepper-label">Question Manager</span>
                    </a>
                  </div>
                </li>
                <li>
                  <div class="step">
                    <a routerLinkActive="active" [routerLink]="['/quiz/other/settings']" [queryParams]="{ id: quizId }"
                       type="button" class="step-trigger"
                       role="tab" id="advancedSettings"
                       >
                      <span class="bs-stepper-label">Advanced Settings</span>
                    </a>
                  </div>
                </li>
              </ul>
            </li>
            <hr>
            <li>
              <a (click)="toggleTestProgressAndResultsDropdown()" data-toggle="collapse"
                 class="dropdown-toggle cursor-pointer">Test
                progress & results</a>
              <ul *ngIf="isTestProgressAndResultsDropdownOpen" class="list-unstyled">
                <li>
                  <div class="step">
                    <a routerLinkActive="active" [routerLink]="['/quiz/respondent/monitoring']" [queryParams]="{ id: quizId }"
                       type="button" class="step-trigger"
                       role="tab" id="respondentMonitoring">
                      <span class="bs-stepper-label">Respondent monitoring</span>
                    </a>
                  </div>
                </li>
                <li>
                  <div class="step">
                    <a routerLinkActive="active" [routerLink]="['/quiz/results/table']" [queryParams]="{ id: quizId }"
                       type="button" class="step-trigger"
                       role="tab" id="resultsTable">
                      <span class="bs-stepper-label">Results table</span>
                    </a>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </ng-container>

    <div class="col-md-9 custom-h-100vh" [class]="isMobile ? 'w-100 pt-3 h-100 bg-white' : 'min-vh-79'">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<div class="modal fade" id="change-quiz-status-modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" *ngIf="!hasQuizQuestions">
      <div class="modal-header">
        <h5 class="modal-title">This quiz has no questions.</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Please add questions to the test.
      </div>
    </div>

    <div class="modal-content" *ngIf="hasQuizQuestions">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ getQuizStatus() === QuizStatus.ACTIVE ? 'End Test' : 'Test Activation' }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        {{
          getQuizStatus() === QuizStatus.ACTIVE ?
            'Are you sure you want to end this test?' :
            'Are you sure you want to activate this test? Make sure all settings are correct.'
        }}
        <div class="d-flex justify-content-end mt-3">
          <button data-bs-dismiss="modal" class="btn btn-secondary me-2">No</button>
          <button data-bs-dismiss="modal" class="btn btn-primary" (click)="changeQuizStatus()">Yes</button>
        </div>
      </div>
    </div>
  </div>
</div>
